import { Component, OnInit, inject } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-cookie-policy',
    templateUrl: './cookie-policy.component.html',
    styleUrls: ['./cookie-policy.component.scss'],
    imports: [BreadCrumbComponent]
})
export class CookiePolicyComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    const title = 'Cookie Policy';
    this.titleService.set(title);
    this.breadcrumbService.set(title);
    this.headService.setMetaDescription(title);
  }
}
